import styled from "styled-components"
import Sidebar from "../components/Sidebar"
import PieChart from "../components/charts/PieChart"
import Navbar from "../components/Navbar"
import logo from '../assets/images/logo-main.png'
import { useActionsContext } from "../context/ActionsContext"
import DetectDevice from "../context/DetectDevice"
import { Link } from "react-router-dom"
import React, { useContext, useEffect, useState } from "react"
import audio from "../assets/audio/notif.mp3";
import axios from "axios"
import ENDPOINT from "../context/EndPoint"

import { ref, push, onValue, getDatabase } from "firebase/database";
import firebaseConfig from '../firebase-Config.js'
import { AuthContext } from "../context/AuthContext"
function NavbarTheme({ children, showsidebar, shownavbar, account }) {

const {user} = useContext(AuthContext)
  const {togglesidebar,settogglesidebar} = useActionsContext()
const device = DetectDevice()

useEffect(()=>{

  if(device==="mobile"){
    settogglesidebar(false)
  }

},[window.location.href,window.location])


const pathname = window.location.pathname;


useEffect(()=>{

updateActivity();

},[pathname])



const updateActivity = async (status)=>{
        

  const formData = new FormData();
  
  
  //formData.append('whyus',document.getElementById('whyus').value)
  if(user){

    formData.append('session',user.SessionId);
  
  }
 
  
    formData.append('page',pathname);
  
  
  const res = await axios.post(ENDPOINT+"save-activity.php", formData,{
      headers: {
          'content-type': 'multipart/form-data'
      }
  });
  if(res){
   // console.log("activity "+JSON.stringify(res))
  
 
  }
  }
  const [notifications,setnotifications] = useState(null);
  const [unread,setunread] = useState(0);
  const [canPlayAudio, setCanPlayAudio] = useState(false);
  const dbRef = ref(
    getDatabase(),
    account ? "/admins/"+account.user_id + "/notifications" : "anonymous",
  );
  
  
    useEffect(() => {
      // Listen for changes in the 'messages' node in the database
      onValue(dbRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const messageList = Object.values(data);
          if (account) {
            getnotifications();
            //console.log("retreving data");
          }
        }
      });
    }, [account]);
  
  const  getnotifications = async ()=>{
     //// console.log("getting notifications")
  try{
    fetch(`${ENDPOINT}get-notifications.php?session=${user.SessionId}`)
    .then(r=>r.json())
    .then(result=>{
      
        
   if(result[0].status==="success"){
       
  
    if((result[0].data)!==null){
      if (result[0].unread > unread && canPlayAudio) {
        const audioElem = document.getElementById("audio");
        if (audioElem) {
          audioElem.play().catch(() => {});
        }
      }
        setnotifications(result[0].data);
     setunread(result[0].unread)
     
    }
  
   }
    
                
    
        
    })
  }
  catch{
  
  }
    
    }    ;
    // var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    // (function(){
    // var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    // s1.async=true;
    // s1.src='https://embed.tawk.to/5ce961ada667a0210d596bb1/default';
    // s1.charset='UTF-8';
    // s1.setAttribute('crossorigin','*');
    // s0.parentNode.insertBefore(s1,s0);
    // })();
  return (

    <>
 <audio className="d-none" id="audio" src={audio} />



      <>
        {/* Begin page */}
        <div id="layout-wrapper">
          {shownavbar ?
          <>
            <Navbar account={account} />
            <h1 className="mb-5"></h1>
           

     
</>
            : null}
 {/* ========== App Menu ========== */}
 <div className={(showsidebar && togglesidebar)?"app-menu navbar-menu override-sidebar":togglesidebar?"app-menu navbar-menu":"app-menu navbar-menu d-none"}>
                {/* LOGO */}
                <div className="navbar-brand-box">

           <Link to="/">       <img className="w-100 mt-2" src={logo}></img></Link>
                  <hr></hr>
                </div>
                <div className="dropdown sidebar-user m-1 rounded">
                  <button
                    type="button"
                    className="btn material-shadow-none"
                    id="page-header-user-dropdown"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"  
                    aria-expanded="false"
                  >
                    <span className="d-flex align-items-center gap-2">
                      <img
                        className="rounded header-profile-user"
                        src="assets/images/users/avatar-1.jpg"
                        alt="Header Avatar"
                      />
                      <span className="text-start">
                        <span className="d-block fw-medium sidebar-user-name-text">
                          Anna Adame
                        </span>
                        <span className="d-block fs-14 sidebar-user-name-sub-text">
                          <i className="ri ri-circle-fill fs-10 text-success align-baseline" />{" "}
                          <span className="align-middle">Online</span>
                        </span>
                      </span>
                    </span>
                  </button>
                  <div className="dropdown-menu dropdown-menu-end">
                    {/* item*/}
                    <h6 className="dropdown-header">Welcome Anna!</h6>
                    <a className="dropdown-item" href="pages-profile.html">
                      <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">Profile</span>
                    </a>
                    <a className="dropdown-item" href="apps-chat.html">
                      <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">Messages</span>
                    </a>
                    <a className="dropdown-item" href="apps-tasks-kanban.html">
                      <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">Taskboard</span>
                    </a>
                    <a className="dropdown-item" href="pages-faqs.html">
                      <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">Help</span>
                    </a>
                    <div className="dropdown-divider" />
                    <a className="dropdown-item" href="pages-profile.html">
                      <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">
                        Balance : <b>$5971.67</b>
                      </span>
                    </a>
                    <a className="dropdown-item" href="pages-profile-settings.html">
                      <span className="badge bg-success-subtle text-success mt-1 float-end">
                        New
                      </span>
                      <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">Settings</span>
                    </a>
                    <a className="dropdown-item" href="auth-lockscreen-basic.html">
                      <i className="mdi mdi-lock text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle">Lock screen</span>
                    </a>
                    <a className="dropdown-item" href="auth-logout-basic.html">
                      <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />{" "}
                      <span className="align-middle" data-key="t-logout">
                        Logout
                      </span>
                    </a>
                  </div>
                </div>


                <div className="overflow-y-scroll">
                  <Sidebar  account={account}/>
                </div>  <div className="sidebar-background" />

              </div>































          {/* Left Sidebar End */}
          {/* Vertical Overlay*/}
          <div className="vertical-overlay" />
          {/* ============================================================== */}
          {/* Start right Content here */}
          {/* ============================================================== */}
          <div className={showsidebar &&togglesidebar? "main-content" : "main-content ms-0"}>
            <div className={shownavbar ? "page-content" : "page-content pt-0"}>
              {children}
            </div>

          </div>
          {/* end main content*/}
        </div>
        {/* END layout-wrapper */}
        {/*start back-to-top*/}
        <button
          onclick="topFunction()"
          className="btn btn-danger btn-icon"
          id="back-to-top"
        >
          <i className="ri-arrow-up-line" />
        </button>
        {/*end back-to-top*/}
        {/*preloader*/}



        {/* JAVASCRIPT */}
        {/* apexcharts */}
        {/* Vector map*/}
        {/*Swiper slider js*/}
        {/* Dashboard init */}
        {/* App js */}
      </>


    </>
  )


}

export default NavbarTheme



const StyledSuperAdminDashboard = styled.div`



h1{

    color:red;
}




`